var _path, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageIconGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.68237 19.37L7.94614 19.5217C9.22658 20.2579 10.6787 20.6458 12.1667 20.6458C16.8532 20.6458 20.6458 16.8538 20.6458 12.1667C20.6458 7.48016 16.8538 3.6875 12.1667 3.6875C7.48016 3.6875 3.6875 7.47953 3.6875 12.1667C3.6875 13.6546 4.07548 15.1067 4.81164 16.3872L4.9633 16.651L4.87004 16.9406L3.68896 20.6083L3.68892 20.6084C3.68566 20.6186 3.68832 20.6298 3.69594 20.6374C3.70355 20.645 3.71473 20.6476 3.72501 20.6444L7.68237 19.37ZM7.68237 19.37L7.39274 19.4633L3.72516 20.6443L7.68237 19.37Z",
    stroke: "#717171",
    strokeWidth: 1.375
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.4987,
    cy: 12.0002,
    r: 0.916667,
    fill: "#717171"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.1667,
    cy: 12.0002,
    r: 0.916667,
    fill: "#717171"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.8327,
    cy: 12.0002,
    r: 0.916667,
    fill: "#717171"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIconGray);
export default __webpack_public_path__ + "static/media/Message-Icon-Gray.670cf1c98563340a60e4193af206a886.svg";
export { ForwardRef as ReactComponent };